import validate from "/var/www/projects/nuxt.hillceramic.no/releases/20261105081907Z/node_modules/nuxt/dist/pages/runtime/validate.js";
import review_45query_45global from "/var/www/projects/nuxt.hillceramic.no/releases/20261105081907Z/middleware/review-query.global.js";
export const globalMiddleware = [
  validate,
  review_45query_45global
]
export const namedMiddleware = {
  "prefetch-page": () => import("/var/www/projects/nuxt.hillceramic.no/releases/20261105081907Z/middleware/prefetch-page.ts")
}